 angular.module('qkr.department').directive('listActionButton', listActionButton);

    listActionButton.$inject = ['appConfig', 'departmentService', 'merchantService', '$uibModal',
    'gettextCatalog', 'messageService'];

    function listActionButton(appConfig, departmentService, merchantService, $uibModal,
                          gettextCatalog, messageService) {
        const departmentStatus = {
            PENDING: 'Pending',
            NOT_SHARED: 'Not Shared',
            SHARED: 'Shared'
        };

        return {
            template: require('../../department/directives/list.action.button.html'),
            scope: {
                department: '=',
                isSupplier: '=',
                isModalOpen: '=',
                loadDepartmentOnController: '&',
                editDepartmentOnController: '&'
            },
            link(scope) {
                scope.SHOW_OR_HIDE = 'SHOW_HIDE';
                scope.CANCEL_SHARE = 'CANCEL_SHARE';
                scope.SHARE = 'SHARE';
                scope.UN_SHARE = 'UN_SHARE';
                scope.ACCEPT_OR_REJECT = 'ACCEPT_REJECT';

                scope.editActionDepartment = function(department) {
                    scope.editDepartmentOnController({department});
                };

                scope.hideOrShowDepartment = function(department) {
                    department.offline = !department.offline;

                    departmentService.updateDepartmentPost(department)
                        .then((response) => {
                                console.log('Updated ', response);
                            }, (reason) => {
                                console.error(reason);
                            });
                };

                scope.acceptShareDepartment = function(department) {
                    departmentService.acceptShare(department).then(() => {
                        // Empty the array to avoid caching
                        // DepartmentService.departmentList = [];
                        scope.loadDepartmentOnController();
                    });
                };

                scope.unshareDepartment = function(department) {
                    scope.isModalOpen = true;
                    const modalInstance = $uibModal.open({
                        template: require('../../templates/common/modalDialog.html'),
                        controller: 'commonModalDialogController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return gettextCatalog.getString('Unsharing Department');
                            },
                            confirmButtonName() {
                                return gettextCatalog.getString('Unshare');
                            },
                            confirmMsg() {
                                return gettextCatalog.getString('Are you sure you want to unshare this department?');
                            },
                            multiMsgArray() {
                                return [];
                            }
                        }
                    });

                    modalInstance.result.then((result) => {
                        scope.isModalOpen = false;
                        if (result === 'ok') {
                            departmentService.unshareDepartmentPost(department).then((promise) => {
                                scope.loadDepartmentOnController();
                            }, (promise) => {
                                if (promise.data.exception) {
                                    messageService.error(promise.data.exception);
                                }
                            });
                        }
                    }, (reason) => {
                        console.error(reason);
                    });
                };

                scope.shareDepartment = function(department) {
                    scope.isModalOpen = true;
                    const modalInstance = $uibModal.open({
                        template: require('../../department/templates/shareDepartment.html'),
                        controller: 'ShareDepartmentManagmentModalDialogController as vm',
                        windowClass: 'modal-huge',
                        backdrop: 'static',
                        resolve: {
                            department() {
                                return department;
                            }
                        }
                    });

                    modalInstance.result.then((result) => {
                        scope.isModalOpen = false;
                        if (result === 'done') {
                            scope.loadDepartmentOnController();
                        }
                    }, (reason) => {
                        console.error(reason);
                    });
                };

                scope.deleteDepartment = function(department) {
                    scope.isModalOpen = true;
                    const modalInstance = $uibModal.open({
                        template: require('../../templates/common/modalDialog.html'),
                        controller: 'commonModalDialogController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return gettextCatalog.getString('Delete Department');
                            },
                            confirmButtonName() {
                                return gettextCatalog.getString('Delete');
                            },
                            confirmMsg() {
                                return gettextCatalog.getString('Deleting parts of Qkr! may have a negative impact on your ability to generate reports in future and other unintended consequences. We strongly recommend you use Hide rather than Delete with the Qkr! Store Manager. Are you sure you still wish to proceed with this delete command?');
                            },
                            multiMsgArray() {
                                return [];
                            }
                        }
                    });

                    modalInstance.result.then((result) => {
                        scope.isModalOpen = false;
                        if (result === 'ok') {
                            departmentService.deleteDepartmentPost(department)
                                .then(() => {
                                    scope.loadDepartmentOnController();
                                }, (reason) => {
                                    if (reason.data.exception) {
                                        messageService.error(reason.data.exception);
                                    }
                                });
                        }
                    }, (reason) => {
                        console.error(reason);
                    });
                };

                scope.cancelShareDepartment = function(department) {
                    departmentService.cancelShareRequestDepartmentPost(department.shareRequestId)
                        .then(() => {
                            scope.loadDepartmentOnController();
                        }, (reason) => {
                            messageService.error(reason);
                        });
                };

                scope.isVisible = function(department, type) {
                    if (type === scope.SHOW_OR_HIDE) {
                        return department.shareStatus === departmentStatus.PENDING ? false :
                            merchantService.behaviour(merchantService.merchantInfo, 'departmentListPage.allowedHideShowDept');
                    } else if (type === scope.CANCEL_SHARE) {
                        return !scope.isSupplier ? false : department.status === departmentStatus.PENDING;
                    } else if (type === scope.SHARE) {
                        return !scope.isSupplier ? false : department.status === departmentStatus.NOT_SHARED;
                    } else if (type === scope.UN_SHARE) {
                        return !scope.isSupplier ? false : department.status === departmentStatus.SHARED;
                    } else if (type === scope.ACCEPT_OR_REJECT) {
                        return scope.isSupplier ? false : department.shareStatus === departmentStatus.PENDING;
                    }
                };
            }
        };
    }



// WEBPACK FOOTER //
// ./src/department/directives/list.action.button.directive.js